export const NOTIFICATION_CONFITMATION_MODAL_SHOWN_ONCE_KEY = 'HAS_CONFIRMATION_MODAL_BEEN_SHOWN_ONCE';
